// @ts-nocheck -- this is a polyfill for BigInt
const BASE57_ALPHABET =
	"23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

function encodeBase57(number: bigint): string {
	if (number === 0n) {
		return BASE57_ALPHABET[0];
	}
	let base57 = "";
	let n = number;
	while (n > 0n) {
		const rem = Number(n % 57n);
		base57 = BASE57_ALPHABET[rem] + base57;
		n = n / 57n;
	}
	return base57;
}

export function suuid(): string {
	// Generate a standard UUID
	const standardUuid = crypto.randomUUID();

	// Convert the UUID to a BigInt
	const uuidInt = BigInt(`0x${standardUuid.replace(/-/g, "")}`);

	// Encode the BigInt in base57
	return encodeBase57(uuidInt);
}
